<template>
  <div :class="{ map__wrapper: true, 'map__wrapper--b2b': isB2BPlatform }">
    <div class="map__header">
      <router-link :to="{ name: 'platform-home' }" class="map__header-nav">
        <font-awesome-icon icon="angle-left" />
        <span>Back</span>
      </router-link>
      <div class="map__header-title">
        <h1>Accounts</h1>
        <p>Create, manage and sign in to your accounts.</p>
      </div>
    </div>
    <ez-nav class="map__navigation">
      <template #nav>
        <ul>
          <li v-if="premiumAccountsLength">
            <router-link :to="{ name: 'manage-accounts-premium' }"> Premium </router-link>
          </li>
          <li v-if="freemiumAccountsLenght">
            <router-link :to="{ name: 'manage-accounts-freemium' }"> Freemium </router-link>
          </li>
        </ul>
      </template>
      <router-view
        @numberOfFreemiumAccounts="updateNumberOfFreemiumAccounts"
        @numberOfPremiumAccounts="updateNumberOfPremiumAccounts"
      />
    </ez-nav>
  </div>
</template>

<script>
import EzNav from '@/components/ui/Nav';

export default {
  components: {
    EzNav,
  },
  data() {
    return {
      premiumAccountsLength: null,
      freemiumAccountsLenght: null,
    };
  },
  methods: {
    updateNumberOfFreemiumAccounts(val) {
      this.freemiumAccountsLenght = val;
    },
    updateNumberOfPremiumAccounts(val) {
      this.premiumAccountsLength = val;
      if (this.premiumAccountsLength === 0 && this.freemiumAccountsLenght !== 0)
        this.$router.push({ name: 'manage-accounts-freemium' });
    },
  },
  computed: {
    isB2BPlatform() {
      return ![
        'localhost',
        'app-dev.orderez.co',
        'app-dev.foodrazor.co',
        'app-staging.orderez.co',
        'app-staging.foodrazor.co',
        'app.orderez.co',
        'app.foodrazor.com',
      ].includes(window.location.hostname);
    },
  },
};
</script>

<style lang="scss" scoped>
.map {
  &__wrapper {
    padding: 80px 120px 60px 120px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    &::after {
      content: '';
      flex: 1;
    }

    &-nav {
      flex: 1;
      display: flex;
      align-items: center;
      color: $color-gray-6C;
      font-weight: 400;
      font-size: 24px;
      text-decoration: none;
      span {
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
      }
      svg {
        margin-right: 8px;
      }
    }

    &-title {
      text-align: center;
      h1 {
        margin-bottom: 8px;
        margin-top: 0;
        color: $color-gray-25;
        font-size: 24px;
        line-height: 32px;
        font-weight: 600;
      }
      p {
        margin: 0;
        color: $color-gray-6C;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }

  :deep() &__navigation {
    a {
      font-size: 14px;
      line-height: 20px;
    }
  }
}

@media (max-width: 768px) {
  .map {
    &__wrapper {
      padding: 24px;
    }

    &__header {
      &-title {
        p {
          display: none;
        }
        h1 {
          margin-bottom: 0;
        }
      }
    }
  }
}

@media (max-width: 556px) {
  .map {
    &__header {
      margin-bottom: 0px;
      &-nav {
        width: 36px;
        height: 36px;
        background-color: #f5f6fa;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 1 auto;
        span {
          display: none;
        }
        svg {
          margin-right: 0;
        }
      }
      &::after {
        flex: 0 1 36px;
      }
    }
  }
}

.map__wrapper.map__wrapper--b2b {
  :deep() .navigation__nav {
    display: none;
  }
}
</style>
